<template>
  <funnels-item-view v-if="mode === 'item'"
    :rawData="funnelData" :device="device" :infoData="infoData" @onDeviceChange="device = $event"/>
  <funnels-session-list v-else
    :rawData="funnelData" :device="device" :infoData="infoData" :onDeviceChange="device = $event"/>
</template>

<script>
import store from '@/store'
import { mapState, mapMutations } from 'vuex'
import { getReport } from '@/api/funnel'
import FunnelsItemView from '@/components/funnels/FunnelsItemView'
import FunnelsSessionList from '@/components/funnels/FunnelsSessionList'
import { parse, format, isBefore, isValid, addDays } from 'date-fns'
import { getDefaultDevice, utcToLocalTimezone } from '@/libs/utils'
import { getBasicInfoData } from '@/api/report'

export default {
  name: 'FunnelsView',
  components: {
    FunnelsItemView,
    FunnelsSessionList
  },
  data () {
    return {
      mode: 'item',
      device: 'desktop',
      infoData: [],
      isLoadedOnce: false
    }
  },
  computed: {
    ...mapState([
      'reportPeriod',
      'funnelData',
      'applyData'
    ])
  },
  watch: {
    reportPeriod (newValue, oldValue) {
      if (newValue.isFunnelMinSet === oldValue.isFunnelMinSet) { // if just min date has changed, pass
        this.loadData()
      }
    },
    device () {
      if (this.isLoadedOnce) {
        this.loadData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'setFunnelData',
      'setReportPeriod'
    ]),
    async loadData () {
      if (this.$route.name === 'funnel.view') {
        const fid = this.$route.params.fid
        const period = this.reportPeriod
        if (!this.isLoadedOnce) {
          this.device = this.$route.params.device || this.$route.query.device
          this.infoData = this.$route.params.infoData
          this.isLoadedOnce = true
        }

        const getBasicInfoDataParam = {
          aid: this.$route.query.faid,
          startDate: this.reportPeriod.start,
          endDate: this.reportPeriod.end
        }

        await getBasicInfoData(getBasicInfoDataParam).then(async res => {
          if (res.pv !== 0) {
            if (!this.device) {
              this.device = await getDefaultDevice(res)
            }
          } else {
            if (!this.device) {
              this.device = 'desktop'
            }
          }
          this.infoData = res
        })

        const params = {
          fid,
          startDate: period.start,
          endDate: period.end,
          device: this.device || this.$route.query.device
        }

        getReport(params).then(data => {
          this.setFunnelData(data.funnel)
          this.mode = this.$route.name === 'funnel.view' ? 'item' : 'sessionList'
        }).catch(err => {
          console.error(err)
        })
      } else {
        this.mode = this.$route.name === 'funnel.view' ? 'item' : 'sessionList'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    const fid = to.params.fid
    const timezoneName = to.params.timezoneName || to.query.timezoneName || from.query.timezoneName
    const device = to.params.device || to.query.device || from.query.device

    if (!fid) {
      alert('no fid')
      return next(false)
    }

    const period = store.state.reportPeriod
    const applyData = store.state.applyData

    const today = new Date()
    const endDate = format(utcToLocalTimezone(today, applyData.timezoneName), 'YYYY-MM-DD')
    const startDate = format(addDays(utcToLocalTimezone(today, applyData.timezoneName), -6), 'YYYY-MM-DD')

    const params = {
      fid,
      startDate: startDate,
      endDate: endDate,
      device: device
    }

    getReport(params).then(data => {
      const funnelRegDate = format(utcToLocalTimezone(data.funnel.regDate, timezoneName), 'YYYY-MM-DD')
      const funnelRegDateValid = isValid(new Date(funnelRegDate))
      store.commit('setFunnelData', data.funnel)
      store.commit('setReportPeriod', {
        ...period,
        min: (funnelRegDateValid && !period.isFunnelMinSet ? funnelRegDate : period.min),
        funnelMin: (funnelRegDateValid && !period.isFunnelMinSet ? period.min : funnelRegDate),
        start: (funnelRegDateValid && isBefore(new Date(startDate), new Date(funnelRegDate)) ? funnelRegDate : startDate),
        end: (funnelRegDateValid && isBefore(new Date(endDate), new Date(funnelRegDate)) ? funnelRegDate : endDate),
        isFunnelMinSet: true
      })
      next(vm => {
        vm.mode = to.name === 'funnel.view' ? 'item' : 'sessionList'
        vm.loadData()
      })
    }).catch(err => {
      console.error(err)
      next(false)
    })
  },
  beforeRouteLeave (to, from, next) {
    const funnelRegDateValid = isValid(new Date(this.reportPeriod.funnelMin))
    this.setReportPeriod({
      ...this.reportPeriod,
      funnelMin: (funnelRegDateValid ? this.reportPeriod.min : this.reportPeriod.funnelMin),
      min: (funnelRegDateValid ? this.reportPeriod.funnelMin : this.reportPeriod.min),
      isFunnelMinSet: false
    })
    next()
  }
}
</script>

<style>

</style>
